import { render, staticRenderFns } from "./newOldHome.vue?vue&type=template&id=e5fbc11c&scoped=true&"
import script from "./newOldHome.vue?vue&type=script&lang=js&"
export * from "./newOldHome.vue?vue&type=script&lang=js&"
import style0 from "./newOldHome.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newOldHome.vue?vue&type=style&index=1&id=e5fbc11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fbc11c",
  null
  
)

export default component.exports